import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import PostService from 'app_services/campus/postService'
import { IPost, PostLocations } from 'app_types/campus/postTypes'
import React, { FC, useCallback, useEffect, useState } from 'react'
import NewsListItem from '../NewsListItem/NewsListItem'
import './NewsList.scss'

interface INewsListProps {
  location: PostLocations
  id?: string
}

const NewsList: FC<INewsListProps> = ({ location, id }) => {
  const postService = new PostService()
  const [news, setNews] = useState<IPost[]>([])

  const getNews = useCallback(async () => {
    let httpParams: any = {
      pageNumber: 1,
      nPerPage: 3,
      isActive: true,
      postType: ['news'],
      postDate: {
        date: 'today',
        direction: 'lte'
      },
      locations: [location],
      sort: {
        field: 'postDate',
        direction: -1
      }
    }
    const response = await postService.fetchPosts(httpParams)
    if (response && response.posts?.length) {
      setNews(response.posts)
    } else {
      setNews([])
    }
  }, [])

  useEffect(() => {
    getNews()
  }, [getNews])

  return (
    <div className="news-list--layout">
      <TextComponent id={id} type="subtitle">Mantengámonos al día</TextComponent>
      <div className="news-list--container-list">
        {news?.map((post) => (
          <NewsListItem post={post} key={post._id} />
        ))}
      </div>
    </div>
  )
}

export default NewsList
